import { Typography } from '@mui/material';
import type { ReactNode } from 'react';

import { useColors } from '../ThemeProvider';

interface Props {
  children: ReactNode;
  color?:
    | 'primary'
    | 'black'
    | 'white'
    | 'grey'
    | 'darkGrey'
    | 'textDisabled'
    | 'error'
    | 'success'
    | 'warning';
  align?: 'left' | 'center' | 'right';
  bold?: boolean;
  italic?: boolean;
  fontSize?:
    | '0.5rem'
    | '0.75rem'
    | '0.875rem'
    | '1rem'
    | '1.125rem'
    | '1.25rem'
    | '1.35rem'
    | number;
}

export function Text({
  color = 'black',
  align = 'left',
  bold = false,
  italic = false,
  fontSize = '1rem',
  children,
}: Props) {
  const colors = useColors();

  return (
    <Typography
      textAlign={align}
      color={colors[color]}
      maxWidth="75ch"
      whiteSpace="pre-wrap"
      fontSize={fontSize}
      sx={{ wordBreak: 'break-word', wordWrap: 'break-word' }}
    >
      {bold && <strong>{children}</strong>}

      {italic && <em>{children}</em>}

      {!bold && !italic && children}
    </Typography>
  );
}
